// 3D Ship on about-us page.
import { Bitmap, Shape, Stage, Text, Ticker, Touch } from '@createjs/easeljs';

const $ = jQuery;
const $window = $(window);

const initShipInteractive3d = () => {
  const els = once('3d-ship-interactive', '.p-st-3d-ship-interactive');
  els.forEach((el) => {
    const $wrapper = $(el);
    const $canvasWrapper = $wrapper.find('.pst-animation-container');
    const $featureText = $wrapper.find('.pst-feat-text');

    const baseURL = window.location.origin;
    const customTextStartFrameAttribute = 'sframe'; // name of attribute containing the srart frame @ which the text is displayed
    const customTextEndFrameAttribute = 'eframe'; // name of attribute containing the end frame @ which text is displayed
    const triggerDistance = 10; // controls mouse move sensitivity (higher number = less sensitive
    const rotateOnClick = true; // enable / disable image rotation by 1 frame on click (without drag)
    const imgCount = 142;

    const imgList = [];
    for (let i = 0; i <= imgCount; i++) {
      imgList.push(
        `${baseURL}/sites/default/files/2021-09/POV85_Studio${`000${i}`.slice(
          -3,
        )}.jpg`,
      );
    }
    const sFrames = [];
    const eframes = [];
    for (let x = 0; x < $featureText.length; x++) {
      sFrames[x] = parseInt(
        $featureText[x].getAttribute(customTextStartFrameAttribute),
      );
      eframes[x] = parseInt(
        $featureText[x].getAttribute(customTextEndFrameAttribute),
      );
    }

    const canvas = $('#pst-animation-canvas').get(0);
    if (!canvas || !canvas.getContext) return;

    // this seems to be from easeljs, last updated 6 years ago :0
    const stage = new Stage(canvas);
    stage.enableMouseOver();
    stage.mouseMoveOutside = true;
    stage.isDragged = false;
    Touch.enable(stage);

    // ---------------------
    // mouse event listeners
    // ---------------------
    function handleClick(event) {
      // check not to fire click after dragging
      if (stage.isDragged == false) {
        if (event.rawX <= 512) {
          update360(1);
        } else {
          update360(-1);
        }
      }
    }

    if (rotateOnClick) {
      stage.on('click', handleClick);
    }

    function handleMouseDown(event) {
      startX = event.rawX;
    }
    stage.on('mousedown', handleMouseDown);

    function handlePressUp(event) {
      // reset isDragged so it can be clicked
      stage.isDragged = false;
      $canvasWrapper.css('cursor', 'pointer');
    }
    stage.on('pressup', handlePressUp);

    function handlePressMove(event) {
      // set isDragged to prevent click from firing
      $canvasWrapper.css('cursor', 'ew-resize');
      stage.isDragged = true;
      const dx = event.rawX - startX;
      const abs_dx = Math.abs(dx);

      if (abs_dx > triggerDistance) {
        update360(-dx / abs_dx);
        startX = event.rawX;
      }
    }
    stage.on('pressmove', handlePressMove);

    const images = [];
    let loaded = 0;
    let currentFrame = 0;
    const totalFrames = imgList.length;
    let startX;

    // Loading progress bar
    const bg = new Shape();
    stage.addChild(bg);

    const bmp = new Bitmap();
    stage.addChild(bmp);

    // Display Loading text while animation is loading
    const loadingTxt = new Text('Loading...', '24px Arial', '#000000');
    loadingTxt.x = canvas.width / 2;
    loadingTxt.y = canvas.height / 2;
    loadingTxt.textAlign = 'center';
    stage.addChild(loadingTxt);

    function load360Image() {
      const imgObj = new Image();
      imgObj.src = imgList[loaded];
      imgObj.onload = function () {
        img360Loaded(this);
      };
      imgObj.crossOrigin = ''; // avoid cross origin errors thrown by some browsers
      images[loaded] = imgObj;
    }

    // moving the bar after each image is loaded
    function img360Loaded(imgObj) {
      const w = stage.canvas.width;
      const h = stage.canvas.height;

      const xRatio = w / imgObj.width;
      const yRatio = h / imgObj.height;
      const scale = Math.min(xRatio, yRatio);

      bmp.scaleX = bmp.scaleY = scale;
      bmp.x = (w - imgObj.width * scale) / 2;
      bmp.y = (h - imgObj.height * scale) / 2;

      loaded += 1;
      bg.graphics.clear();
      bg.graphics
        .beginFill('#808080')
        .drawRect(
          0,
          stage.canvas.height - 10,
          (stage.canvas.width * loaded) / totalFrames,
          10,
        );
      bg.graphics.endFill();
      if (loaded != totalFrames) {
        load360Image();
      } else {
        start360();
        stage.removeChild(bg);
      }
    }

    // Icon display for "360 rotation" bottom left
    function iconLoaded(event) {
      const iconBmp = new Bitmap();
      iconBmp.image = event.target;
      iconBmp.x = 20;
      iconBmp.y = canvas.height - iconBmp.image.height - 20;
      stage.addChild(iconBmp);
    }

    function start360() {
      $canvasWrapper.css('cursor', 'pointer');
      // remove loading text
      stage.removeChild(loadingTxt);
      // 360 icon
      const iconImage = new Image();
      iconImage.src = `${baseURL}/sites/default/files/2021-09/rotate360.png`; // @todo probably
      iconImage.onload = iconLoaded;
      // update-draw
      update360(0);
    }

    // rotation control
    function update360(dir) {
      currentFrame += dir;
      if (currentFrame < 0) {
        currentFrame = totalFrames - 1;
      } else if (currentFrame > totalFrames - 1) {
        currentFrame = 0;
      }
      displayCustomDiv(currentFrame);
      bmp.image = images[currentFrame];
    }

    // display custom feature texts
    function displayCustomDiv(cFrame) {
      for (let j = 0; j < $featureText.length; j++) {
        if (sFrames[j] <= cFrame && eframes[j] >= cFrame) {
          $featureText[j].style.display = 'block';
        } else {
          $featureText[j].style.display = 'none';
        }
      }
    }

    $canvasWrapper.css('cursor', 'progress');

    load360Image();

    // TICKER
    Ticker.addEventListener('tick', handleTick);
    Ticker.framerate = 60;
    Ticker.useRAF = true;

    function handleTick() {
      stage.update();
    }
  });
};

$window.on('load', () => initShipInteractive3d());
